module.exports = __webpack_public_path__ + "img/921_green_Round.0facef25.svg";